import React from 'react';
import recipientIcon from './../.../../../../assets/svg/recipient.svg';
import clapIcon from './../.../../../../assets/svg/clap.svg';
import { CoreBadge } from '../../../RnRCommonComponent';
import formatDate from './../../models/commonDateUtils.jsx';
import clapBlue from './../../../assets/svg/clap_blue.svg';
import { ReloadOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { addCommas } from '../../../rewardsAndRecognitionHelper/utils.js';

const NewestFeed = (props) => {
	const {
		feedListData,
		handleClapCount,
		fetchMoreData,
		isLoadMoreCalled,
		hasMoreData,
	} = props;

	return (
		<>
			{feedListData &&
				feedListData?.map((item, index) => {
					return (
						<div key={index}>
							<div className="feed-card" key={index}>
								<div
									className="about-feed"
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										flexDirection: 'column',
										rowGap: '10px',
									}}
								>
									{item.employee != null && (
										<div style={{ display: 'flex', alignItems: 'center' }}>
											<div className="feed-author">
												<div className="feed-img">
													<img src={recipientIcon} alt="img" />
												</div>
												<div className="feed-name">
													{item?.employee.firstName} {item.employee.lastName}
												</div>
											</div>
											{item?.badge?.badgeType?.code ? (
												<div className="feed-reward-logo">
													<CoreBadge
														badgeType={item?.badge?.badgeType?.code}
														badgeIcon={item?.badge?.icon?.code}
														label={item?.badge?.label}
														color={item?.badge?.color}
													/>
												</div>
											) : (
												<></>
											)}
											{item?.points && item?.points === 0 ? (
												<></>
											) : (
												item?.points > 0 && (
													<div className="feed-points">
														+{addCommas(item?.points)} points
													</div>
												)
											)}
										</div>
									)}
								</div>

								{item?.content?.message && (
									<div
										className="feed-reply py-2"
										style={{ wordWrap: 'break-word' }}
									>
										{item?.content?.message}
									</div>
								)}

								{item?.content?.gifURL && (
									<div className="feed-image my-2">
										<img
											src={item?.content?.gifURL}
											style={{ height: 236, width: '100%' }}
										/>
									</div>
								)}
								<div className="send-by d-flex align-items-center justify-content-end">
									<div className="send-by-text">Sent by</div>
									<div className="send-by-name">
										{item?.sentBy?.firstName} {item?.sentBy?.lastName}
									</div>
								</div>
							</div>
							<div className="d-flex align-items-center justify-content-between card-detail">
								<div className="d-flex align-items-center">
									<img
										src={
											item?.feedInteraction?.click === true
												? clapBlue
												: clapIcon
										}
										onClick={() => {
											handleClapCount(
												item.id,
												!item?.feedInteraction?.click,
												item.feedInteraction.id
											);
										}}
										style={{ cursor: 'pointer' }}
										className="clap-icon pr-1"
									/>
									<div>{item?.feedInteraction?.totalCounts}</div>
								</div>
								<div
									style={{ color: '#b1b1b1' }}
									className="d-flex align-items-center"
								>
									{formatDate(item?.createdAt, true)}
								</div>
							</div>
						</div>
					);
				})}
			{hasMoreData ? (
				<div>
					{isLoadMoreCalled ? (
						<Spin className="d-flex align-items-center justify-content-center w-100 h-100" />
					) : (
						<div
							className="cursor-pointer d-flex align-items-center justify-content-center"
							onClick={() => {
								fetchMoreData();
							}}
						>
							<ReloadOutlined className="mr-1" />
							Load More
						</div>
					)}
				</div>
			) : (
				<></>
			)}
		</>
	);
};

export default NewestFeed;
